export const permissionsIdToName = {
  // System bypass all scope
  sys: 'system',

  // Recruiter Scopes
  adm_r: 'admin_r',
  adm_w: 'admin_w',
  adm_d: 'admin_d',

  // Affinity
  aff_r: 'affinity_r',

  // AI Content
  ai_c: 'ai_content',

  // Branding
  br_es: 'branding',

  // Company Scopes
  cadm_r: 'company_admin_r',
  cadm_w: 'company_admin_w',
  cadm_d: 'company_admin_d',

  // Affinity Contacts
  caff_r: 'affinity_contacts_r',

  // Chatbot
  cb: 'chatbot',

  // User Scopes
  cd_r: 'candidate_r',
  cd_w: 'candidate_w',
  cd_d: 'candidate_d',

  // Competency Framework individual
  cfi_r: 'competency_framework_ind_r',
  cfi_w: 'competency_framework_ind_w',
  cfi_d: 'competency_framework_ind_d',

  // Competency Framework group
  cfg_r: 'competency_framework_group_r',
  cfg_w: 'competency_framework_group_w',
  cfg_d: 'competency_framework_group_d',

  // Campaign Scopes
  cmp_r: 'campaign_r',
  cmp_w: 'campaign_w',
  cmp_d: 'campaign_d',

  // Invite
  inv_cta: 'invite_cta',
  inv_link: 'invitation_link',

  // Mobility Scopes
  mbt_r: 'mobility_r',
  mbt_w: 'mobility_w',
  mbt_d: 'mobility_d',

  // Manager fit
  mf_r: 'management_fit_r',
  mf_dd: 'management_fit_dd',

  // MFA
  mfa_req: 'mfa_req',

  // Manager Scopes
  mng_a: 'manager_a',
  mng_r: 'manager_r',
  mng_w: 'manager_w',
  mng_d: 'manager_d',

  // Predictive Model AI
  pmai_r: 'predictive_model_ai_r',
  pmai_w: 'predictive_model_ai_w',
  pmai_d: 'predictive_model_ai_d',

  // Predictive Model
  pm_r: 'predictive_model_r',
  pm_w: 'predictive_model_w',
  pm_d: 'predictive_model_d',

  // Predictive Model job offer
  pm_jo: 'predictive_model_jo',

  // predict success
  ps_u: 'predict_success_u',

  // Recruiter Scopes
  rct_r: 'recruiter_r',
  rct_w: 'recruiter_w',
  rct_d: 'recruiter_d',

  // Skill
  sai_r: 'scope_ai',

  // SCREENING
  sc: 'screening',

  // Talent Mapper
  ta: 'talent_analysis',

  // Voice
  vc: 'voice'
};
